import { render } from "./LinksTable.vue?vue&type=template&id=3db8ad9d&scoped=true"
import script from "./LinksTable.vue?vue&type=script&lang=js"
export * from "./LinksTable.vue?vue&type=script&lang=js"

import "./LinksTable.vue?vue&type=style&index=0&id=3db8ad9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8ad9d"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTooltip});
